import { skipIfNull } from '@proscom/prostore';
import { useGraphqlWatchQuery } from '@proscom/prostore-apollo-react';
import { QUERY_CONTEST_DOCS_FOR_SS_MONITORING_ENTITY } from '../../graphql/queries/contestDocsMonitoring';

const contestDocsForSSMonitoringEntityQueryOptions = {
  query: QUERY_CONTEST_DOCS_FOR_SS_MONITORING_ENTITY,
  mapData: (data) => data.tenderDocumentationForSS,
  skipQuery: skipIfNull(null)
};

export function useContestDocsForSSMonitoringEntity(input) {
  return useGraphqlWatchQuery({
    queryOptions: contestDocsForSSMonitoringEntityQueryOptions,
    variables: input ? { input } : null,
    options: {
      apolloOptions: {
        fetchPolicy: 'network-only'
      }
    }
  });
}
